import en from "./en.json";
import transitions from "./en-translations.json";

export const labels = en;
export const translations = transitions;
